import { Link } from "react-router-dom";

function MenuList({ data, className }) {
  return (
    <>
      {
        <ul className={className ? className : ""}>
          {data.map(({ id, title, to }) => (
            <li key={id+title}>
              <Link to={to}>{title}</Link>
            </li>
          ))}
        </ul>
      }
    </>
  );
}

export default MenuList;
